import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ForgotPassword/ForgotPassword.tsx")